import { SliceZone } from "@prismicio/react";
import { createClient } from "../../prismicio";
import { components } from "../../slices";
import { Meta } from "@/components";
import IndustryCourses from "@/slices/IndustryCourses";

const Training = ({ page, industries, courses }) => {
  return (
    <>
      <Meta
        metaTitle={page?.data?.meta_title}
        metaDescription={page?.data?.meta_description}
        socialShareImage={page?.data?.meta_image?.url}
      />
      <main>
        <SliceZone
          slices={page.data.slices}
          components={{
            ...components,
            industry_courses: (props) => (
              <IndustryCourses
                industries={industries}
                courses={courses}
                {...props}
              />
            ),
          }}
        />
      </main>
    </>
  );
};

export default Training;

export async function getStaticProps({ previewData }) {
  const client = createClient({ previewData });
  const page = await client.getSingle("training");
  const nav = await client.getSingle("nav");
  const footer = await client.getSingle("footer");
  const industries = await client.getAllByType("industry");
  const courses = await client.getAllByType("course", {
    graphQuery: `
    {
      course {
        featured_image
        card_title
        card_description
        industries
        priority
      }
    }
  `,
  });

  console.debug("courses: ", courses);

  return {
    props: {
      nav,
      page,
      footer,
      industries,
      courses,
    },
  };
}
